import classNames from 'classnames'
import { memo } from 'react'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import { tcgLandUrl } from '@/utils/constants'
import getRandomAd from '@/utils/getRandomAd'

import styles from './Adhesion.module.scss'

type Props = {
  enableDesktop: boolean
}

// Mobile adhesion is ALWAYS enabled
const Adhesion = ({ enableDesktop }: Props) => {
  const randomAdMobile = getRandomAd('tcg.land/mobile')
  const randomAdDesktop = getRandomAd('tcg.land/desktop')
  return (
    <div className={styles.container}>
      <OutboundLink
        className={classNames({ 'dev-ad': process.env.NODE_ENV !== 'production' })}
        url={tcgLandUrl}
        utm_medium='adhesion-mobile'
      >
        <img
          alt='TCG.Land'
          className={classNames('d-flex d-md-none', { 'opacity-0': process.env.NODE_ENV !== 'production' })}
          src={randomAdMobile.src}
        />
      </OutboundLink>
      {enableDesktop && (
        <OutboundLink
          className={classNames({ 'dev-ad': process.env.NODE_ENV !== 'production' })}
          url={tcgLandUrl}
          utm_medium='adhesion-desktop'
        >
          <img
            alt='TCG.Land'
            className={classNames('d-none d-md-flex', { 'opacity-0': process.env.NODE_ENV !== 'production' })}
            src={randomAdDesktop.src}
          />
        </OutboundLink>
      )}
    </div>
  )
}

export default memo(Adhesion)
